import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { api, formatError } from "@/lib/api";

export default function ForgotPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatError(err));
    }
  };

  return (
    <AuthShell kicker="Recupero" title="Reimposta la password.">
      {sent ? (
        <p className="text-base" data-testid="forgot-success">
          Se l'indirizzo è registrato, abbiamo generato un link di reimpostazione valido per 1 ora.
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-8">
          <label className="block">
            <span className="rf-mono text-[11px] uppercase tracking-widest text-[var(--rf-grey)]">Email</span>
            <input type="email" required className="rf-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          </label>
          {error && <p className="text-sm rf-red" data-testid="forgot-error">{error}</p>}
          <button className="rf-btn" data-testid="forgot-submit-button">Invia link</button>
        </form>
      )}
      <Link to="/login" className="inline-block mt-12 text-sm underline underline-offset-4 hover:text-[var(--rf-red)]" data-testid="forgot-back-link">
        ← Torna all'accesso
      </Link>
    </AuthShell>
  );
}
